import { render, staticRenderFns } from "./welcomenote.vue?vue&type=template&id=9ed52548&scoped=true&"
import script from "./welcomenote.vue?vue&type=script&lang=js&"
export * from "./welcomenote.vue?vue&type=script&lang=js&"
import style0 from "./welcomenote.vue?vue&type=style&index=0&id=9ed52548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed52548",
  null
  
)

export default component.exports